/*
 * Broadcast Theme
 *
 * Questo file è pensato per aggiungere codice JavaScript personalizzato al tema Broadcast.
 * Mantenere il codice personalizzato qui faciliterà gli aggiornamenti futuri del tema.
 *
 * NOTA: Per usare questo file, aprire il file /layout/theme.liquid e decomentare l'import dello script custom.js.
 */

/*
 * Evento DOMContentLoaded:
 * Otteniamo la variante iniziale e aggiorniamo lo stato del pulsante ATC.
 */
document.addEventListener('DOMContentLoaded', function() {
  // add param to URL if not present
  const url = new URL(window.location.href);
  const variantIdParam = url.searchParams.get('variant');
  const variant = getInitialVariant();
  if (!variantIdParam) {
    if (variant) {
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  updateAddToCartState(variant);
});

/*
 * Evento theme:variant:change:
 * Emesso quando la variante del prodotto cambia: aggiorniamo lo stato del pulsante ATC.
 */
document.addEventListener('theme:variant:change', function(e) {
  const variant = e.detail.variant;
  updateAddToCartState(variant);
});

/*
 * GLINT: true se la variante ha il metafield "Blocca prevendita" (custom.disable_preorder) = true,
 * stock > 0 e il prodotto ha il tag badge:pre-ordine.
 * La lista viene esposta da theme.liquid in window.__RIFO__.blockedVariants.
 */
function isRifoBlocked(variant) {
  const blocked = (window.__RIFO__ && window.__RIFO__.blockedVariants) || [];
  return !!variant && blocked.indexOf(String(variant.id)) > -1;
}

// GLINT: variante correntemente selezionata, usata per riapplicare la label "Prevendita chiusa"
let rifoCurrentVariant = null;

function rifoBlockedLabel() {
  const s = (window.theme && theme.strings) || {};
  return s.preorderClosed || s.soldOut || '';
}

// GLINT: riapplica la label se il tema la sovrascrive (aggiornamenti asincroni market IT / pickup map)
function rifoApplyBlockedLabel() {
  if (!isRifoBlocked(rifoCurrentVariant)) return;
  const btn = document.querySelector('.button-add-to-cart');
  const txt = btn && btn.querySelector('[data-add-to-cart-text]');
  const label = rifoBlockedLabel();
  if (txt && label && txt.textContent !== label) {
    txt.textContent = label;
  }
}

function updateAddToCartState(variant) {
  rifoCurrentVariant = variant || null;

  const addToCartButton = document.querySelector('.button-add-to-cart');
  const notifyButton = document.querySelector('.klaviyo-bis-trigger');

  if (!addToCartButton || !notifyButton) {
    return;
  }

  if (!variant) {
    addToCartButton.style.display = 'block';
    addToCartButton.disabled = false;
    notifyButton.style.display = 'none';
    return;
  }

  // GLINT: variante con "Blocca prevendita" → solo bottone "Prevendita chiusa", niente "Lista d'attesa"
  if (isRifoBlocked(variant)) {
    addToCartButton.style.display = 'block';
    addToCartButton.disabled = true;
    notifyButton.style.display = 'none';
    rifoApplyBlockedLabel();
    return;
  }

  if (!variant.available) {
    addToCartButton.style.display = 'none';
    addToCartButton.disabled = true;
    notifyButton.style.display = 'block';
  } else {
    addToCartButton.style.display = 'block';
    addToCartButton.disabled = false;
    notifyButton.style.display = 'none';
  }
}

// GLINT: observer sul testo del bottone, attivo solo sui prodotti con varianti bloccate
document.addEventListener('DOMContentLoaded', function () {
  const blocked = (window.__RIFO__ && window.__RIFO__.blockedVariants) || [];
  if (!blocked.length) return;
  const txt = document.querySelector('.button-add-to-cart [data-add-to-cart-text]');
  if (!txt) return;
  new MutationObserver(rifoApplyBlockedLabel).observe(txt, {
    childList: true,
    characterData: true,
    subtree: true
  });
});

/*
 * Funzione getInitialVariant():
 * Recupera la variante iniziale del prodotto basandosi sullo stato attuale della pagina:
 * parametro "variant" nell'URL, altrimenti taglia selezionata, altrimenti prima variante.
 */
function getInitialVariant() {
  const productJsonElement = document.querySelector('[data-product-json]');
  if (!productJsonElement) {
    return null;
  }

  let productData = null;
  try {
    productData = JSON.parse(productJsonElement.innerHTML);
  } catch (e) {
    return null;
  }

  if (!productData || !productData.variants || !productData.variants.length) {
    return null;
  }

  const url = new URL(window.location.href);
  const variantIdParam = url.searchParams.get('variant');
  if (variantIdParam) {
    const matchedVariant = productData.variants.find(v => v.id == variantIdParam);
    if (matchedVariant) {
      return matchedVariant;
    }
  } else {
    // Check for a selected size option from the radio buttons
    const selectedSizeInput = document.querySelector('#taglia .radio__button>input:checked');
    if (selectedSizeInput) {
      const matchingVariant = productData.variants.find(v => v.option1 === selectedSizeInput.value);
      if (matchingVariant) return matchingVariant;
    }
  }

  return productData.variants[0];
}

/*
 * Cookiebot: riapre il banner cookie dal link "#cookie-settings"
 */
document.addEventListener("DOMContentLoaded", function () {
  const cookieLink = document.querySelector('a[href="#cookie-settings"]');
  if (cookieLink) {
    cookieLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (typeof Cookiebot !== "undefined") {
        Cookiebot.renew();
      }
    });
  }
});

/*
 * === Complementary Products Loader (per Broadcast) ===
 * Carica dinamicamente i prodotti complementari nel cart drawer,
 * usando l'API Shopify Search & Discovery e renderizzandoli con le card corrette (upsell-product con quick add).
 */
function loadComplementaryProducts() {
  const container = document.querySelector('[data-complementary-products-container]');
  if (!container) return;

  // Get all product IDs from cart
  fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) {
        container.style.display = 'none';
        return;
      }

      const productIds = cart.items.map(item => item.product_id);
      const allProducts = [];
      const seenProductIds = new Set();

      // Helper function to fetch and parse products
      const fetchProducts = (productId, intent) => {
        const root = window.Shopify?.routes?.root || '/';
        const url = `${root}recommendations/products?section_id=api-product-complementary-upsell&intent=${intent}&limit=8&product_id=${productId}`;

        return fetch(url)
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;

            const template = temp.querySelector('[data-api-complementary-upsell-template]');
            if (template) {
              const inner = template.content ? template.content.cloneNode(true) : template;
              const products = inner.querySelectorAll('quick-add-product');
              const foundProducts = [];

              products.forEach(p => {
                // Get product ID from the quick-add-holder to avoid duplicates
                const holder = p.querySelector('[data-quick-add-holder]');
                if (holder) {
                  const prodId = holder.getAttribute('data-quick-add-holder');
                  // Skip if product is already in cart or already added
                  if (!seenProductIds.has(prodId) && !productIds.includes(parseInt(prodId))) {
                    seenProductIds.add(prodId);
                    foundProducts.push(p.cloneNode(true));
                  }
                }
              });

              return foundProducts;
            }
            return [];
          })
          .catch(err => {
            console.error(`Fetch error (${intent}):`, err);
            return [];
          });
      };

      // Fetch complementary products for each product in cart, fallback to related if no complementary
      const fetchPromises = productIds.map(productId => {
        return fetchProducts(productId, 'complementary')
          .then(complementaryProducts => {
            if (complementaryProducts.length > 0) {
              return complementaryProducts;
            }
            return fetchProducts(productId, 'related');
          });
      });

      // Wait for all fetches to complete, then insert products
      Promise.all(fetchPromises).then(results => {
        results.forEach(products => {
          products.forEach(p => allProducts.push(p));
        });

        // Limit to first 8 products
        const limitedProducts = allProducts.slice(0, 8);

        if (limitedProducts.length > 0) {
          container.innerHTML = '';
          container.style.display = '';
          limitedProducts.forEach(p => {
            p.style.display = '';
            container.appendChild(p);
          });
        } else {
          container.style.display = 'none';
        }
      });
    })
    .catch(err => console.error('Cart fetch error:', err));
}

// --- Esegui quando la pagina o il carrello vengono aggiornati ---
document.addEventListener('DOMContentLoaded', loadComplementaryProducts);
document.addEventListener('theme:cart:change', loadComplementaryProducts);
document.addEventListener('theme:cart-drawer:open', loadComplementaryProducts);